/**
 * 内置虚拟提供商 ID。
 *
 * 官方模型由本站服务端转发，不写入 `providers` 表；会话仍会绑定这个 ID。
 * 备份校验等纯数据层需要识别它，因此放在无副作用的独立模块里。
 */
export const SERVER_PROVIDER_ID = '__zhixin_server__';
